module.exports = __webpack_public_path__ + "img/christmas_cover_photo.c67388fc.jpeg";